// Styles
import './Tag.scss';

// Libs
import React, { useMemo } from 'react';

// Components
import Picture from '@/common/components/atoms/Picture/Picture';

// PropTypes
import { TagDefaultProps, TagPropTypes } from './Tag.proptypes';

const Tag = ({ className, label, tag }) => {
  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['tag', className].filter((val) => val).join(' '),
    [className],
  );

  if (tag) {
    return (
      <div className={classNames} data-qa-id="tag">
        <Picture alt={label} src={tag} className="tag__picture" />
      </div>
    );
  }

  return null;
};

Tag.defaultProps = {
  ...TagDefaultProps,
};

Tag.propTypes = {
  ...TagPropTypes,
};

export default Tag;
